const blue10 = "#fcfcff";
const blue25 = "#f6f9fe";
const blue50 = "#e8effa";
const blue100 = "#b8cff0";
const blue200 = "#96b7e9";
const blue300 = "#6696df";
const blue400 = "#4982d9";
const blue500 = "#1b63cf";
const blue600 = "#195abc";
const blue700 = "#134693";
const blue800 = "#0f3672";
const blue900 = "#0b2a57";
const blues = {
  blue10,
  blue25,
  blue50,
  blue100,
  blue200,
  blue300,
  blue400,
  blue500,
  blue600,
  blue700,
  blue800,
  blue900
};
export {
  blue10,
  blue100,
  blue200,
  blue25,
  blue300,
  blue400,
  blue50,
  blue500,
  blue600,
  blue700,
  blue800,
  blue900,
  blues as default
};
//# sourceMappingURL=index.es4.js.map
